<template>
  <scroll-bar>
    <el-menu
      mode="vertical"
      :default-active="$route.path"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
    >
      <sidebar-item :routes="permission_routers"></sidebar-item>
    </el-menu>
  </scroll-bar>
</template>

<script>
import SidebarItem from "./SidebarItem";
import ScrollBar from "@/components/ScrollBar";

export default {
  components: { SidebarItem, ScrollBar },
  data() {
    return {
      permission_routers:[],
    };
  },
  created() {
    this.permission_routers=this.$router.options.routes
  },
  mounted() {
    console.log(this.$router.options.routes, "bar");
  },
};
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue